module.exports = __webpack_public_path__ + "img/card-online-pre-registration.02653f58.svg";